import React from "react";
import { useSelector } from "react-redux";

import BasicInfo from "./components/Profile/BasicInfo";

const Profile = () => {
  const userDetail = useSelector((state) => state.basicInfo.userDetails);

  return (
    <div className="row justify-content-center">
      <BasicInfo userID={userDetail?.id} />
    </div>
  );
};

export default React.memo(Profile);
